// extracted by mini-css-extract-plugin
export default {"tablaTotales":"Totales_tablaTotales__VRDRa","total":"Totales_total__bUcaH","detalle":"Totales_detalle__0CF3I"};